import { Link } from "gatsby"
import PropTypes from "prop-types"
import React from "react"

import moodboardLogo from "../images/moodboard-logo.svg"

const Header = ({ siteTitle }) => (
  <header
    style={{
      display: `flex`,
    }}
  >
    <div
      style={{
        margin: `0 auto`,
        padding: `1.45rem 1.0875rem`,
      }}
    >
      <h1 style={{ margin: `0 auto` }}>
        <Link to="/">
          <img src={moodboardLogo} alt={siteTitle} />
        </Link>
      </h1>
    </div>
  </header>
)

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
